import { GraphQLRequestClient } from '@sitecore-jss/sitecore-jss-nextjs';

export interface SitecoreRoute {
	id: string;
	url: string;
	label: string;
	newTab: boolean;
}

interface SitecoreRawRoute {
	item: {
		children: SitecoreRawChildren;
	};
}
interface SitecoreRawChildren {
	results: {
		url: {
			path: string;
		};
		displayName: string;
		id: string;
		openInANewTab: {
			boolValue: boolean;
		};
		link?: {
			jsonValue: { value: { href: string } };
		};
		children: SitecoreRawChildren;
	}[];
}

export const GetSitecoreRoutes = async (id: string, language: string): Promise<Array<SitecoreRoute>> => {
	const result = await Request(id, language, getPagesGraphQL);
	const routes = new Array<SitecoreRoute>();
	GetChildren(result.item.children, routes);
	return routes;
};

const GetChildren = (children: SitecoreRawChildren, routes: Array<SitecoreRoute>) => {
	children?.results.forEach((child) => {
		const route: SitecoreRoute = {
			id: child.id,
			url: child.link ? child.link?.jsonValue?.value?.href : child.url.path,
			label: child.displayName,
			newTab: child.openInANewTab?.boolValue ?? false,
		};
		routes.push(route);
		GetChildren(child.children, routes);
	});
};

const Request = async (dataSource: string, language: string, gql: string): Promise<SitecoreRawRoute> => {
	const gqlClient = new GraphQLRequestClient(String(process.env.GRAPH_QL_ENDPOINT), {
		apiKey: process.env.SITECORE_API_KEY,
	});

	return await gqlClient.request<SitecoreRawRoute>(gql, {
		datasource: dataSource,
		language,
	});
};

const getPagesGraphQL = `
# Write your query or mutation here
query GetPages($datasource: String!, $language: String!) {
  item(path: $datasource, language: $language) {
    children(
      first: 30
      includeTemplateIDs: "{2BD4D193-B2D2-4DF4-B2DA-4E851E1E8D49}"
    ) {
      results {
        url {
          path
        }
        displayName
        id
        ... on _BasePage {
          openInANewTab {
            boolValue
          }
        }
        ... on _RedirectPage {
          link {
            jsonValue
          }
        }
        children(
          first: 30
          includeTemplateIDs: "{2BD4D193-B2D2-4DF4-B2DA-4E851E1E8D49}"
        ) {
          results {
            url {
              path
            }
            displayName
            id
            ... on _BasePage {
              openInANewTab {
                boolValue
              }
              ... on _RedirectPage {
                link {
                  jsonValue
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
